import React from 'react';
import classnames from 'classnames';

import { IInner, IOuter } from './DropZone.types';

export const DropZoneComponent: React.FC<IOuter & IInner> = ({
  connectDropTarget,
  isOver,
  canDrop,
  className,
  activeClassName,
  draggingClassName,
  children,
  onClick,
  dataHook,
}) =>
  connectDropTarget(
    <div
      className={classnames(className, {
        [draggingClassName]: canDrop,
        [activeClassName]: canDrop && isOver,
      })}
      onClick={onClick}
      data-hook={dataHook}
    >
      {children}
    </div>,
  );
